import monchromaticimage from "../assests/our_services_assets/p_img.jpg";
import { OFFERINGS } from "../component/pages/Offerings/Constant";
import { CATEGORY_META, CATEGORY_HERO, CATEGORY_HERO_PORTRAIT, CATEGORY_ITEMS } from "../component/pages/Portfolio/Constant";
import { GameBannerDetails } from "../component/Games/Constant";

// Every image the Home route can show, across every offering tab and every
// portfolio card — preloaded up front so switching tabs never flashes a bare
// background before its image arrives.
export const HOME_IMAGES: string[] = [
  monchromaticimage,
  ...OFFERINGS.flatMap((offering) => [offering.bg, offering.icon]),
  ...Object.values(CATEGORY_META).map((meta) => meta.image),
];

// Every thumbnail + title image across every game, regardless of which tab
// is active, so switching tabs on /game never shows a blank thumbnail.
export const GAME_IMAGES: string[] = GameBannerDetails.flatMap((game) => {
  const images = [game.imageSource];
  if (game.title) images.push(game.title);
  return images;
});

// All hero + carousel images for a single portfolio category. Carousel
// videos are intentionally excluded — they stream, they don't need preload.
export function getPortfolioCategoryImages(category?: string): string[] {
  const hero = category ? CATEGORY_HERO[category] : undefined;
  const heroPortrait = category ? CATEGORY_HERO_PORTRAIT[category] : undefined;
  const items = (category ? CATEGORY_ITEMS[category] : undefined) ?? [];
  return [hero, heroPortrait, ...items.map((item) => item.image)].filter(
    (url): url is string => Boolean(url)
  );
}
